import { useContext } from 'react';
import CourseContext from './context';

const useCourse = () => useContext(CourseContext);

export default useCourse;
